import { Router } from "@angular/router";
import { TowerService } from "./api/service/tower.service";
import { NavigationService } from "./shared/navigation.service";
import { isNullOrUndefined } from "util";
var AppComponent = /** @class */ (function () {
    function AppComponent(router, towerService, navigationService) {
        this.router = router;
        this.towerService = towerService;
        this.navigationService = navigationService;
    }
    AppComponent.prototype.allowedLogs = function () {
        var token = this.navigationService.getToken();
        if (!isNullOrUndefined(token)) {
            for (var _i = 0, _a = token.features; _i < _a.length; _i++) {
                var feature = _a[_i];
                if (feature === 'logs') {
                    return true;
                }
            }
        }
        return false;
    };
    AppComponent.prototype.allowedQueues = function () {
        var token = this.navigationService.getToken();
        if (!isNullOrUndefined(token)) {
            for (var _i = 0, _a = token.features; _i < _a.length; _i++) {
                var feature = _a[_i];
                if (feature === 'queues') {
                    return true;
                }
            }
        }
        return false;
    };
    AppComponent.prototype.debranchements = function () {
        var token = this.navigationService.getToken();
        if (!isNullOrUndefined(token)) {
            return token.debranchements;
        }
        return [];
    };
    AppComponent.prototype.actionDebranchement = function (id) {
        this.towerService.getDebranchementUrl(id).subscribe(function (response) {
            window.open(response.url, '_blank');
        }, function (error) {
            alert('Erreur durant le debranchement');
        });
    };
    AppComponent.prototype.actionQueues = function () {
        this.router.navigate(['/queues']);
    };
    AppComponent.prototype.actionLogs = function () {
        this.router.navigate(['/logs']);
    };
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// ./src/app/app.component.ts.pre-build-optimizer.js